var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow/left-double") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.1,0.5 L12.5,1.82432432 L6.5,7.5 L0.5,1.82432432 L1.9,0.5 L6.5,4.85135135 L11.1,0.5 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1,0.5 L12.5,1.82432432 L6.5,7.5 L0.5,1.82432432 L1.9,0.5 L6.5,4.85135135 L11.1,0.5 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow/left-double",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow/base",
    transform: "translate(3.500000, 6.000000) rotate(-270.000000) translate(-3.500000, -6.000000) translate(-3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/primary-blue-100%-Copy",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    opacity: 0.699999988,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/primary-blue-100%",
    mask: "url(#mask-2)",
    fill: "#7C8195"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 0,
    y: 0,
    width: 13,
    height: 8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "arrow/base",
    transform: "translate(9.500000, 6.000000) rotate(-270.000000) translate(-9.500000, -6.000000) translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/primary-blue-100%-Copy",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    opacity: 0.699999988,
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/primary-blue-100%",
    mask: "url(#mask-4)",
    fill: "#7C8195"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 0,
    y: 0,
    width: 13,
    height: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDouble);
export default __webpack_public_path__ + "static/media/left-double.e7e2643120923603f511e8cc82d78594.svg";
export { ForwardRef as ReactComponent };